/**
 * Enum for funding source provider labels
 * @enum {string}
 * @readonly
 */
export const FundingSourceProviderLabels = Object.freeze({
  AIRWALLEX: 'Airwallex',
});

/**
 * Enum for funding source statuses
 * @enum {string}
 * @readonly
 */
export const FundingSourceStatus = Object.freeze({
  CREATED: 'CREATED',
  PROCESSING: 'PROCESSING',
  ACTIVE: 'ACTIVE',
  ACTIVATED: 'ACTIVATED',
  SUSPENDED: 'SUSPENDED',
  FAILED: 'FAILED',
  CLOSED: 'CLOSED',
});

/**
 * Enum for funding source transfer method labels
 * @enum {string}
 * @readonly
 */
export const FundingSourceTransferMethodLabels = Object.freeze({
  SWIFT: 'International SWIFT',
  LOCAL: 'Local',
});

/**
 * Enum for funding source transfer method labels
 * @enum {string}
 * @readonly
 */
export const FundingSourceTransferMethods = Object.freeze({
  SWIFT: 'SWIFT',
  LOCAL: 'LOCAL',
});
